import React from "react";

import './_devices.scss'

import {Breadcrumb, BreadcrumbItem, Column, Grid, Tile} from "@carbon/react";
import {Link, useParams} from "react-router-dom";
import DevicesTable from "../../components/DevicesTable";

const Devices = () => {
  const {systemCode} = useParams();

  return (
    <Grid fullWidth className="devices-page">
      <Column lg={16} md={8} sm={4}>
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to='/customers'>Sistemi</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to={'/customers/' + systemCode}>{systemCode}</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                Strumenti
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              {systemCode === undefined ? "Strumenti" : "Strumenti sistema " + systemCode}
            </h1>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="devices-page__r1">
            <Tile>
              <DevicesTable systemCode={systemCode}/>
            </Tile>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

export default Devices